import { connect } from 'react-redux';

import { changeQuickShopVisibility } from '../actions';
import QuickShopModalTrigger from '../components/QuickShopModalTrigger';

const mapDispatchToProps = dispatch => ({
  openQuickShopModal: (variants, showExciseTaxDisclaimer) => {
    dispatch(
      changeQuickShopVisibility(true, variants, showExciseTaxDisclaimer)
    );
  },
});

export default connect(
  null,
  mapDispatchToProps
)(QuickShopModalTrigger);
